<template lang="pug">
  div.d-flex.align-center.pr-4
    v-checkbox.mr-3(
      v-model="model.filters.is_auto"
      @change="setQuery"
      label="Auto"
    )
    v-checkbox.mr-3(
      v-model="model.filters.is_motor"
      @change="setQuery"
      label="Motor"
    )
    v-checkbox.mr-3(
      v-model="model.filters.is_scooter"
      @change="setQuery"
      label="Scooter"
    )
    v-select.ml-4(
      v-model="model.filters.tenant"
      :items="tenantOptions"
      item-text="name"
      item-value="query"
      label="Tenant"
      clearable
      dense
      style="max-width: 150px;"
      @input="setQuery"
    )
    //div.switch
    //  span Auto
    //  v-switch(
    //    v-model="model.filters.is_auto"
    //    @change="setQuery"
    //  )
    //  span Non-auto
</template>

<script>
import {ExamFiltersModel} from "@/models/filters/ExamFiltersModel";
import {TENANT_OPTIONS} from "@/app/exercise/modules/trainings/core/training-const";

export default {
  props: {
    loading: Boolean,
  },

  data: () => ({
    model: {},
    tenantOptions: TENANT_OPTIONS,
  }),

  created() {
    this.initFilters()
  },

  methods: {
    initFilters() {
      this.model = new ExamFiltersModel(this.$route.query);
    },

    setQuery() {
      this.$emit('filterChanged', this.model.getApiData());
    },
  },
};
</script>

<style lang="scss" scoped>
.v-input::v-deep {
  .v-input__slot {
    margin: 0;
  }
  .v-input__control {
    min-height: auto!important;
  }
  .v-text-field__details {
    display: none;
  }

  .v-messages {
    display: none;
  }

  .v-input--selection-controls__input {
    margin-right: 0;
  }
}

.v-input--selection-controls::v-deep {
  margin: 0;
  padding: 0;
}
</style>